<wl-top-nav></wl-top-nav>

<div class="wc-main-container">
  <div class="wc-main-container-body">
    <div class="container-fluid">
      <wl-workspace></wl-workspace>
    </div>
  </div>

</div>
<wl-footer></wl-footer>
<wl-notification></wl-notification>
